module.exports = __webpack_public_path__ + "static/media/Artboard9.2fae78cc.png";